module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc3-01-f9fec80eda52b3f1e6fd830ef067daba.png";